'use client'

import LogoLargeBlue from '@/assets/logo/logo-large-blue.svg'
import LogoLargeRed from '@/assets/logo/logo-large.svg'

import { cn } from '@/core/lib/utils/cn'

type LogoProps = {
  theme?: 'red' | 'blue'
}

const LogoLarge = ({
  theme = 'blue',
  className,
}: LogoProps & { className?: string }) => {
  return (
    <div className={cn('-ms-8 flex items-center', className)}>
      {theme === 'red' ? (
        <LogoLargeRed className='scale-75' />
      ) : (
        <LogoLargeBlue className='scale-75' />
      )}
      <span className='-ms-4 hidden font-medium min-[68rem]:block'>
        | Premier Airport Transfer
      </span>
    </div>
  )
}

export const Logo = ({ theme = 'blue' }: LogoProps) => {
  if (theme === 'red') {
    return (
      <>
        {/* viewBox is re-added because SVGO strips it, which would crop the logo when resized */}
        <LogoLargeRed
          viewBox='0 0 229 28'
          className='h-auto w-32 shrink-0 sm:w-40 lg:hidden'
        />
        <LogoLarge theme='red' className='hidden lg:flex' />
      </>
    )
  }

  return (
    <>
      <LogoLargeBlue
        viewBox='0 0 210 26'
        className='h-auto w-32 shrink-0 sm:w-40 lg:hidden'
      />
      <LogoLarge className='hidden lg:flex' />
    </>
  )
}
